import { Heading, ThemeColorVariable, ThemeSpaceVariable } from "@caspeco/casper-ui-library";
import { AvailableTimesSection } from "types/available-times";
import { PaymentRule } from "types/payment";
import { TimeSlot } from "types/time-slot";
import { mergeTimeSetsByTitle } from "utils/time-rule-utils";
import TimeSet from "./time-set/time-set";
import { useTimeSetsFilters } from "hooks/use-time-slot-filters";

interface ISectionOfAvailableTimes {
    expanded?: boolean;
    availableTimesSection: AvailableTimesSection;
    selectedTime?: TimeSlot;
    onTimeClickOverride?: (time: TimeSlot) => void;
    isEditBookingMode?: boolean;
}

const SectionOfAvailableTimes = (props: ISectionOfAvailableTimes) => {
    const { bookableTimeSets, waitListTimeSets } = useTimeSetsFilters(
        props.availableTimesSection.timeSets
    );
    const noTimeSetsWithAvailableTimes = !props.availableTimesSection.timeSets.find(
        (x) => x.times.length > 0 || x.isTextRow
    );
    if (noTimeSetsWithAvailableTimes) return null;

    let listOfRules = mergeTimeSetsByTitle([...bookableTimeSets, ...waitListTimeSets]);

    if (props.isEditBookingMode) {
        listOfRules = listOfRules.filter(
            (rule) => !rule.menuGuid && rule.paymentRule === PaymentRule.NoFee
        );
    }

    return (
        <>
            {!props.selectedTime && (
                <Heading
                    as="h5"
                    fontWeight="500"
                    flex="1"
                    textAlign="left"
                    mb={ThemeSpaceVariable.Medium}
                    color={ThemeColorVariable.OnBackgroundHeader}
                >
                    {props.availableTimesSection.name}
                </Heading>
            )}
            {listOfRules.map((timeSet) => (
                <TimeSet
                    key={`timeSet${timeSet.id}`}
                    timeSet={timeSet}
                    selectedTime={props.selectedTime}
                    onTimeClickOverride={props.onTimeClickOverride}
                />
            ))}
        </>
    );
};

export default SectionOfAvailableTimes;
